import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Mail, Lock, ArrowLeft } from "lucide-react";
import AsaLogo from "../components/AsaLogo";
import { useAsaAuth } from "../AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAsaAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Please enter your email and password");
      return;
    }
    try {
      await login({ email, password });
      toast.success("Welcome back!");
      navigate("/asa/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid email or password");
    }
  };

  const field = "w-full h-12 pl-11 pr-4 rounded-lg border border-slate-200 text-[15px] outline-none focus:border-[#0d9488] transition-colors";

  return (
    <div className="min-h-screen bg-[#f4f8f7] flex flex-col items-center justify-center px-4">
      <button onClick={() => navigate("/asa")} className="absolute top-6 left-6 inline-flex items-center gap-1.5 text-slate-500 text-sm hover:text-slate-700"><ArrowLeft size={16} /> Home</button>
      <div className="mb-8"><AsaLogo size={38} /></div>
      <div className="w-full max-w-[440px] bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
        <h1 className="font-head font-bold text-slate-800 text-2xl text-center">Patient Log In</h1>
        <p className="text-center text-slate-500 text-sm mt-1 mb-6">Access your autoimmune health tools</p>
        <form onSubmit={submit} className="space-y-4">
          <div className="relative">
            <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" size={19} />
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" className={field} />
          </div>
          <div className="relative">
            <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" size={19} />
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={field} />
          </div>
          <button type="submit" data-testid="login-submit" className="w-full h-12 rounded-lg bg-[#0d9488] hover:bg-[#0f766e] text-white font-semibold transition-colors">Log In</button>
        </form>
        <button onClick={() => navigate("/asa/forgot-password")} data-testid="forgot-password-link" className="block w-full text-center text-sm text-[#0d9488] font-semibold hover:underline mt-4">I forgot my password</button>
        <p className="text-center text-sm text-slate-500 mt-6">New to ASAL? <button onClick={() => navigate("/asa/register")} className="text-[#0d9488] font-semibold hover:underline">Create an account</button></p>
      </div>
      <p className="text-[12px] text-slate-400 mt-6">© {new Date().getFullYear()} ASA Foundation · Copyright &amp; IP: Asal Shirazi</p>
    </div>
  );
}
